import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from "@angular/forms";
import { AppComponent } from './app.component';
import { Ng2CompleterModule } from "ng2-completer";
import { HttpModule, Http } from '@angular/http';
import { TranslatePipe, TranslateService, TranslateModule, TranslateStaticLoader, TranslateLoader } from 'ng2-translate';
import { RouterModule } from '@angular/router';
import { SuperUserComponent } from './super_user/super-user.component';
import { SuperUserDashboardComponent } from './super_user/dashboard/dashboard.component';
import { SuperUserMessagesComponent } from './super_user/messages/messages.component';
import { SuperUserMessageDetailComponent } from './super_user/messages/message_detail/message-detail.component';
import { SuperUserProfileComponent } from './super_user/profile/profile.component';
import { SuperUserProfileChangeEmailComponent } from './super_user/profile/profile_change_email/profile-change-email.component';
import { SuperUserProfileChangeEmailPasswordComponent } from './super_user/profile/profile_change_email_password/profile-change-email-password.component';
import { SuperUserProfileChangePasswordComponent } from './super_user/profile/profile_change_password/profile-change-password.component';
import { SuperUserProfileChangeSubroleComponent } from './super_user/profile/profile_change_subrole/profile-change-subrole.component';
import { SuperUserProfileEditComponent } from './super_user/profile/profile_edit/profile-edit.component';
import { SuperUserNotificationsComponent } from './super_user/notifications/notifications.component';
import { SuperUserFavoritesComponent } from './super_user/favorites/favorites.component';
import { AgmCoreModule } from 'angular2-google-maps/core';
import { ImageCropperComponent } from './super_user/dashboard/img-cropper/imageCropperComponent';
import { MainComponent } from './main/main.component';
import { MainDashboardComponent } from './main/dashboard/dashboard.component';
import { MainElementDetailComponent } from './main/element_detail/element-detail.component';
import { MainChangePasswordComponent } from './main/change_password/change-password.component';
import { CitiesSeekerComponent } from './main/cities_seeker/cities-seeker.component';
import { TagsHandlerComponent } from './main/tags_handler/tags-handler.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { FaqComponent } from './front/faq/faq.component';
import { InfoComponent } from './front/info/info.component';
import { WhoComponent } from './front/who/who.component';
import { ForumComponent } from './forum/forum.component';
import { ForumDashboardComponent } from './forum/dashboard/dashboard.component';
import { ForumTopicDetailComponent } from './forum/topic_detail/topic-detail.component';
import { ForumMessageChildsComponent } from './forum/topic_detail/message_childs/message-childs.component';
import { MainProfileComponent } from './main/profile/profile.component';
import { MainProfileChangeEmailComponent } from './main/profile/profile_change_email/profile-change-email.component';
import { MainProfileChangeEmailPasswordComponent } from './main/profile/profile_change_email_password/profile-change-email-password.component';
import { MainProfileChangePasswordComponent } from './main/profile/profile_change_password/profile-change-password.component';
import { MainProfileChangeSubroleComponent } from './main/profile/profile_change_subrole/profile-change-subrole.component';
import { MainProfileEditComponent } from './main/profile/profile_edit/profile-edit.component';
import { MainMessagesComponent } from './main/messages/messages.component';
import { MainMessageDetailComponent } from './main/messages/message_detail/message-detail.component';
import { MainFavoritesComponent } from './main/favorites/favorites.component';
import { SuperUserStartComponent } from './super_user/start/start.component';
import { SuperUserVerifyEmailComponent } from './super_user/start/verify_email/verify-email.component';
import { SuperUserLogoutComponent } from './super_user/logout/logout.component';
import { SuperUserProfileChangeCategoryComponent } from './super_user/profile/profile_change_category/profile-change-category.component';
import { MainProfileChangeCategoryComponent } from './main/profile/profile_change_category/profile-change-category.component';
import { SuperUserTransactionReturnComponent } from './super_user/start/transaction_return/transaction-return.component';
import { MainProfileChangeLanguageComponent } from './main/profile/profile_change_language/profile-change-language.component';
import { SuperUserProfileChangeLanguageComponent } from './super_user/profile/profile_change_language/profile-change-language.component';
import { AuthGuard } from './auth-guard.service';
import { AuthService } from './auth.service';

@NgModule({
  imports: [    
    BrowserModule,    
    FormsModule,
    HttpModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyB6uBpi9jOeko0WhohOXd5WKF2moHe2MGc'
    }),
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory: (http: Http) => new TranslateStaticLoader(http, '/assets/i18n', '.json'),
      deps: [Http]
    }),
    RouterModule.forRoot([
      {
        path: 'login',
        component: LoginComponent
      },
      {
        path: 'register',
        component: RegisterComponent
      },
      {
        path: 'faq',
        component: FaqComponent
      },
      {
        path: 'info',
        component: InfoComponent
      },      
      {
        path: 'who',
        component: WhoComponent        
      },    
      {
        path: 'parada/:elementId',
        redirectTo: 'main/elementdetail/:elementId',
        pathMatch: 'full'
      },
      {
        path: 'main',
        component: MainComponent,
        children: [
          { path: 'dashboard', component: MainDashboardComponent },
          { path: 'elementdetail/:elementId', component: MainElementDetailComponent },
          { path: 'elementdetail', component: MainElementDetailComponent },
          { path: 'messages', component: MainMessagesComponent, canActivate: [AuthGuard] },
          { path: 'message', component: MainMessageDetailComponent, canActivate: [AuthGuard] },
          { path: 'profile', component: MainProfileComponent, canActivate: [AuthGuard] },          
          { path: 'favorites', component: MainFavoritesComponent, canActivate: [AuthGuard] },
          { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
        ]
      },
      {
        path: 'forum',
        component: ForumComponent,
        children: [
          { path: 'dashboard', component: ForumDashboardComponent },
          { path: 'topicdetail', component: ForumTopicDetailComponent },
          { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
        ]
      },
      {
        path: 'superuser',
        component: SuperUserComponent,
        canActivate: [AuthGuard],
        children: [
          { path: 'start', component: SuperUserStartComponent },
          { path: 'dashboard', component: SuperUserDashboardComponent },
          { path: 'messages', component: SuperUserMessagesComponent },
          { path: 'message', component: SuperUserMessageDetailComponent },
          { path: 'profile', component: SuperUserProfileComponent },
          { path: 'notifications', component: SuperUserNotificationsComponent },
          { path: 'favorites', component: SuperUserFavoritesComponent },
          { path: 'logout', component: SuperUserLogoutComponent },
          { path: 'transactionReturn/:transactionKey', component: SuperUserTransactionReturnComponent },
          { path: '', redirectTo: 'dashboard', pathMatch: 'full' }
        ]
      },
      {
        path: 'verifyemail/:emailKey',
        component: SuperUserVerifyEmailComponent
      },
      {
        path: 'forgetPassword/:emailKey',
        component: MainChangePasswordComponent
      },
      {
        path: '',
        redirectTo: 'main',
        pathMatch: 'full'
      }
    ], { useHash: true }),
    Ng2CompleterModule,
  ],
  declarations: [
    AppComponent,
    SuperUserComponent,
    SuperUserDashboardComponent,
    SuperUserMessagesComponent,
    SuperUserMessageDetailComponent,
    SuperUserProfileComponent,
    SuperUserProfileChangeEmailComponent,
    SuperUserProfileChangeEmailPasswordComponent,
    SuperUserProfileChangePasswordComponent,
    SuperUserProfileChangeSubroleComponent,
    SuperUserProfileEditComponent,
    SuperUserNotificationsComponent,
    ImageCropperComponent,
    SuperUserFavoritesComponent,
    MainComponent,
    MainDashboardComponent,
    MainChangePasswordComponent,
    CitiesSeekerComponent,
    TagsHandlerComponent,
    MainElementDetailComponent,
    LoginComponent,
    RegisterComponent,
    FaqComponent,
    InfoComponent,
    WhoComponent,
    ForumComponent,
    ForumDashboardComponent,
    ForumTopicDetailComponent,
    ForumMessageChildsComponent,
    MainProfileComponent,
    MainProfileChangeEmailComponent,
    MainProfileChangeEmailPasswordComponent,
    MainProfileChangePasswordComponent,
    MainProfileChangeSubroleComponent,
    MainProfileEditComponent,
    MainMessagesComponent,
    MainMessageDetailComponent,
    MainFavoritesComponent,
    SuperUserStartComponent,
    SuperUserVerifyEmailComponent,
    SuperUserLogoutComponent,
    SuperUserProfileChangeCategoryComponent,
    MainProfileChangeCategoryComponent,
    SuperUserTransactionReturnComponent,
    MainProfileChangeLanguageComponent,
    SuperUserProfileChangeLanguageComponent
  ],
  bootstrap: [AppComponent],
  providers: [
    AuthGuard,
    AuthService
  ]
})
export class AppModule { }


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/app.module.ts
 **/